import React from 'react'

const Health = () => {
  const styleObj = {
    'color': 'rgba(0, 0, 0, 0.2)'
  }
  return ( 
    <div>
      <p id='health-copy'>
        Not sure of what goals to set?
        <br /><br />
        To help you get started with your first month, here's some goals inspiration related to the 3 pillars of health.
      </p>
      <div>
        <h3>Physical</h3>
        <ul>
          <li><span style={styleObj}>Daily:</span> Stretch for 15 minutes</li>
          <li><span style={styleObj}>Weekly:</span> Go for a long walk</li>
          <li><span style={styleObj}>Fortnightly:</span> Go for a 5K run</li>
        </ul>
      </div>
      <div>
        <h3>Mental</h3>
        <ul>
          <li><span style={styleObj}>Daily:</span> Sit still with your thoughts for 5 minutes</li>
          <li><span style={styleObj}>Weekly:</span> Journal about what you are grateful for over the past week</li>
          <li><span style={styleObj}>Fortnightly:</span> Go to a meditation class</li>
        </ul>
      </div>
      <div>
        <h3>Social</h3>
        <ul>
          <li><span style={styleObj}>Daily:</span> Have lunch with a different colleague</li>
          <li><span style={styleObj}>Weekly:</span> Phone home</li>
          <li><span style={styleObj}>Fortnightly:</span> Get in touch with 1 old friend</li>
        </ul>
      </div>
    </div>
   );
}
 
export default Health;